export const isDev = false;

export const WEBSITE = isDev ? 'edcturbo.cn' : 'subiche.cn';

export const WEBNAME = isDev ? '梅香道' : '速比车';

export const ICP = isDev ? '桂ICP备17004753号-2' : '桂ICP备17004753号-4';

export const ICP_YEAR = isDev ? '2021' : '2024';